var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.2,
    height: 24.2,
    viewBox: "0 0 24.2 24.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-dollar-1060275",
    transform: "translate(-142.7 -72.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17278",
    "data-name": "Path 17278",
    d: "M154.8,72.8a11.959,11.959,0,1,0,8.5,3.5A11.919,11.919,0,0,0,154.8,72.8Zm7.557,19.557a10.649,10.649,0,0,1-15.114,0A10.709,10.709,0,0,1,144.1,84.8a10.518,10.518,0,0,1,3.146-7.557A10.709,10.709,0,0,1,154.8,74.1a10.518,10.518,0,0,1,7.557,3.146A10.709,10.709,0,0,1,165.5,84.8,10.518,10.518,0,0,1,162.357,92.358Z",
    fill: "#3b4452",
    stroke: "#3b4452",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17279",
    "data-name": "Path 17279",
    d: "M280.775,178.89v-2.368a2.744,2.744,0,0,1,1.492.843l.324.357,1.265-1.232-.357-.357a4.775,4.775,0,0,0-2.757-1.3V173.6h-1.654v1.232c-1.816.227-3.049,1.33-3.049,2.757,0,1.816,1.654,2.368,3.049,2.724v2.724A3.815,3.815,0,0,1,277.11,182l-.357-.357-1.232,1.265.324.324a5.146,5.146,0,0,0,3.211,1.492v1.2h1.654v-1.2c2.3-.292,3.114-1.654,3.114-2.919.065-1.946-1.751-2.595-3.049-2.919Zm0,4.151v-2.3c.908.292,1.265.616,1.265,1.135C282.04,182.1,281.943,182.815,280.775,183.042Zm-1.654-6.551v1.946c-.843-.259-1.168-.519-1.168-.908C277.954,177.074,278.408,176.652,279.121,176.49Z",
    transform: "translate(-125.035 -94.965)",
    fill: "#3b4452",
    stroke: "#3b4452",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounDollar);
export default __webpack_public_path__ + "static/media/noun_dollar.81525426be37f9b3ba641d58efdf3b3d.svg";
export { ForwardRef as ReactComponent };